export default "__VITE_ASSET__BPUzRV4a__"